import { render, staticRenderFns } from "./ModalPaymentAddOnComponent.vue?vue&type=template&id=68dc7c55"
import script from "./ModalPaymentAddOnComponent.vue?vue&type=script&lang=js"
export * from "./ModalPaymentAddOnComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports